export enum LabelLang {
  IT_IT = "it-IT"
}
